/**
 * Helpers para data-testid dinâmicos (padrão checkout: kebab-case).
 */
const slugify = (value: string): string =>
	value
		.toLowerCase()
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.replace(/\s+/g, '-')
		.replace(/[^a-z0-9-]/g, '');

export { slugify };
